import type { FaireProductEntity } from "../../entity_types/product";

export const p_hgjme93yuj: FaireProductEntity = {
  token: "p_hgjme93yuj",
  type: "product",
  name: "Super Sunny Thank You Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/32936d279954b04746c6cac5347adebc8d58b2ff8c2633a08500c810e7c0a8f3.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/26cade35b6fd34e854f6bb8f100ff92245e4f15302d3e9a0a84ef59d4419941c.webp",
    "https://cdn.faire.com/fastly/9d707e9118afb0875c8775dbe9e4b373bad188b29752b8ae38c7b0230e3bc6eb.png",
  ],
  priceDollars: 11,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:04.014Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
